import LoungePassesHeroSection from './LoungePassesHeroSection'
import LoungePassesHowItWorksSection from './LoungePassesHowItWorksSection'
import LoungePassesDirectorySection from './LoungePassesDirectorySection'
import LoungePassesUpcomingTripsSection from './LoungePassesUpcomingTripsSection'
import LoungePassesYourPassesSection from './LoungePassesYourPassesSection'

function LoungePassesPage() {
  return <div>
    <LoungePassesHeroSection />
    <LoungePassesYourPassesSection />
    <LoungePassesHowItWorksSection />
    <LoungePassesUpcomingTripsSection />
    <LoungePassesDirectorySection />
  </div>
}

export default LoungePassesPage
